import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/login.css';
import logo from '../assets/logo_1.jpg';
import {ip_back , api_key} from '../constants/appConstants';

  const Login = () => {
    const [usuario, setUsuario] = useState('');
    const [contrasena, setPassword] = useState('');
    const navigate = useNavigate();
    const handleLogin = async (e) => {
      e.preventDefault();

      try {
        const response = await fetch(ip_back+'/api/usuarios/inicio_sesion', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': api_key,
          },
          body: JSON.stringify({ "usuario" : usuario, "contrasena" : contrasena }),
        });
  
        if (response.ok) {
          const data = await response.json();
          localStorage.setItem("user", JSON.stringify(data.usuario));
          localStorage.setItem("token", JSON.stringify(data.access_token));
          navigate('/inicio');
        } else {
          alert('Credenciales Inválidas');
        }
      } catch (error) {
        alert('Error al iniciar sesión:');
      }
    };

  return (
    <div className="login-container">
      <img src={logo} alt='Camacho Asesores' className='logo_login'></img>
      <h2>Iniciar Sesión</h2>
      <form onSubmit={handleLogin} className='form_login'>
        <div className="input-group">
          <label>Usuario:</label>
          <input className='login_input'
            type="text"
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
            placeholder="Introduce tu usuario"
            required
          />
        </div>
        <div className="input-group">
          <label>Contraseña:</label>
          <input className='login_input'
            type="password"
            value={contrasena}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Introduce tu contraseña"
            required
          />
        </div>
        <button type="submit">LOGIN</button>
      </form>
    </div>
  );
};

export default Login;
